export const servicesData = [
    {
        link: '/services/digital-strategy',
        title: 'Go to Digital Strategy page',
        name: 'Digital Strategy',
        key: 'DIGITAL_STRATEGY',
    },
    {
        link: '/services/transformation-delivery',
        title: 'Go to Transformation Delivery page',
        name: 'Transformation Delivery',
        key: 'TRANSFORMATION_DELIVERY',
    },
    {
        link: '/services/software-engineering-and-solution-architecture',
        title: 'Go to Software Engineering & Solution Architecture page',
        name: 'Software Engineering & Solution Architecture',
        key: 'SOFTWARE_ENGINEERING_AND_SOLUTION_ARCHITECTURE',
    },
    {
        link: '/services/insights-and-analytics',
        title: 'Go to Insights & Analytics page for more information',
        name: 'Insights & Analytics',
        key: 'INSIGHTS_AND_ANALYTICS',
    },
    {
        link: '/services/quality-assurance-and-test-engineering',
        title: 'Go to Quality Assurance & Test Engineering page',
        name: 'Quality Assurance & Test Engineering',
        key: 'QUALITY_ASSURANCE_AND_TEST_ENGINEERING',
    },
    {
        link: '/services/cloud-and-devops',
        title: 'Go to Cloud & DevOps page',
        name: 'Cloud & Devops',
        key: 'CLOUD_AND_DEVOPS',
    },
    {
        link: '/services/cloud-operations',
        title: 'Go to Cloud Operations page',
        name: 'Cloud Operations',
        key: 'CLOUD_OPERATIONS',
    },
];
